import React, { useEffect } from "react";

const Contact = () => {
  // 카카오(다음) 약도 로더 스크립트를 한 번만 주입하고 지도 렌더
  useEffect(() => {
    const loaderId = "daum-roughmap-loader";
    const renderMap = () => {
      if (window.daum && window.daum.roughmap) {
        new window.daum.roughmap.Lander({
          timestamp: "1686898562395",
          key: "2f7px",
          mapWidth: "100%",
          mapHeight: "360", // 필요 시 500 등으로 조정
        }).render();
      }
    };

    if (!window.daum || !window.daum.roughmap) {
      if (!document.getElementById(loaderId)) {
        const script = document.createElement("script");
        script.id = loaderId;
        script.src =
          "https://ssl.daumcdn.net/dmaps/map_js_init/roughmapLoader.js";
        script.onload = renderMap;
        document.body.appendChild(script);
      } else {
        // 이미 로더가 붙어 있는 경우
        const s = document.getElementById(loaderId);
        if (s && s.readyState === "complete") renderMap();
        else s.addEventListener("load", renderMap, { once: true });
      }
    } else {
      renderMap();
    }
  }, []);

  // 테이블/행 기본 스타일
  const tableStyle = {
    marginBottom: 0,
    fontSize: 14,
  };
  const thStyle = {
    width: 86,
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    borderBottom: "1px solid rgba(255,255,255,.25)",
    padding: ".6rem .8rem",
    opacity: 0.95,
  };
  const tdStyle = {
    verticalAlign: "middle",
    borderBottom: "1px solid rgba(255,255,255,.25)",
    padding: ".6rem .8rem",
    textAlign: "left",
  };

  return (
    <section id="contact" className="contact">
      <div
        className="container-sm px-2"
        data-aos="fade-up"
        data-aos-duration="900"
        style={{ maxWidth: 860 }}
      >
        {/* 지도 (상단만 둥근 모서리) */}
        <div
          style={{
            borderRadius: "10px 10px 0 0",
            overflow: "hidden",
            boxShadow: "0 12px 28px rgba(0,0,0,.35)",
          }}
        >
          <div
            id="daumRoughmapContainer1686898562395"
            className="root_daum_roughmap root_daum_roughmap_landing"
            style={{ width: "100%", height: 360 }}
          />
        </div>

        {/* 정보 패널 (하단만 둥근 모서리) */}
        <div
          className="contact-info"
          style={{
            backgroundColor: "rgba(35,37,41,.88)",
            borderRadius: "0 0 10px 10px",
            color: "#fff",
            lineHeight: "1.9rem",
            padding: "1rem .6rem",
            backdropFilter: "saturate(120%) blur(2px)",
            boxShadow: "0 12px 28px rgba(0,0,0,.35)",
          }}
        >
          <table className="table text-white" style={tableStyle}>
            <tbody>
            <tr>
              <th scope="row" style={thStyle}>
                주소
              </th>
              <td style={tdStyle}>
                서울시 강남구 강남대로 94길 67 도연빌딩 7층
              </td>
            </tr>
            <tr>
              <th scope="row" style={thStyle}>
                위치
              </th>
              <td style={tdStyle}>2호선 역삼역 4번 출구</td>
            </tr>
            <tr>
              <th scope="row" style={thStyle}>
                전화
              </th>
              <td style={tdStyle}>02-554-5131</td>
            </tr>
            <tr>
              <th scope="row" style={{ ...thStyle, borderBottom: "none" }}>
                메일
              </th>
              <td style={{ ...tdStyle, borderBottom: "none" }}>
                victor@amiesoft.com
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Contact;
